import { Dispatch } from "redux";

import { AppConfigsActionDispatchTypes } from "../constants/AppConfigs";
import { updateConfigs } from "../constants/Config";

export const appConfigMiddleware = () => (next: Dispatch) => (action: any) => {
  if (action.type === AppConfigsActionDispatchTypes.APP_CONFIG_SUCCESS) {
    const { response } = action;
    updateConfigs(response);
  }
  return next(action);
};
